/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { answerSchema } from '../answer-types';

export const saveReviewRequestSchema = z.object({
  challengeId: z.number().int(),
  answer: answerSchema,
  timeSpent: z.number().int().min(0),
  sessionId: z.number().int(),
  timestamp: z.number().int().min(0),
  device: z.string().optional(),
  timezone: z.string().min(1).max(64).optional(),
});

export type ISaveReviewRequest = z.infer<typeof saveReviewRequestSchema>;
